import { api, storage } from "@/plugins";

export const authModule = {
  namespaced: true,
  state: () => ({ isAuthenticated: false, userDetails: null }),
  mutations: {
    clearMessage(state) {
      if (state.userDetails) {
        state.userDetails.user_message = null;
      }
    },
    setUserDetail(state, userDetails) {
      state.isAuthenticated = true;
      state.userDetails = userDetails;
    },

    removeUserDetail(state) {
      state.isAuthenticated = false;
      state.userDetails = null;
    },
  },
  actions: {
    async register(
      { storeState, commit, rootState },
      { name, password, email, state, gender, contact_no }
    ) {
      const {
        response: { data },
        error,
      } = await api.registerUser({
        name,
        password,
        email,
        state,
        gender,
        contact_no,
      });
      if (error) return { error, data: null };

      if (data.fail?.email[0] === "The email already registered")
        return { error: "email exist", data: null };

      return { error: null, data: data };
    },

    async login({ state, commit, rootState, dispatch }, { email, password }) {
      const {
        response: { data },
        error,
      } = await api.getUserToken({
        email,
        password,
      });

      if (error) return { error, data: null };

      if (data.fail === "1") return { error: "invalid", data: null };

      if (data.fail === "0") return { error: "verify email", data: null };

      storage.setToken(data.token);
      const userDetail = await dispatch("getUserDetail", {
        token: data.token,
      });

      commit("setUserDetail", userDetail);
      return { error: null, data: data };
    },

    async logout({ commit }) {
      storage.removeToken();
      commit("removeUserDetail");
    },

    async getUserDetail({ commit }, { token }) {
      const {
        response: { data },
        error,
      } = await api.getUserDetailsApi(token);
      if (error || data.status === "Token is Invalid") return null;
      return data;
    },

    async verifyTokenStored({ commit, state }) {
      if (state.isAuthenticated) return true;
      const token = storage.getToken();
      if (!token) return false;
      const {
        response: { data },
        error,
      } = await api.getUserDetailsApi(token);
      if (error || data.status === "Token is Invalid") return false;

      commit("setUserDetail", data);
      return true;
    },
  },
};
